import React from 'react';
import PropTypes from 'prop-types';

import useFileResources from 'components/Common/Users/Hooks/useFileResources';

import DataTable from 'react-data-table-component';
import Loader from 'components/ui/Loader';
import columns from './columns';

export default function Index({ userId }) {
  const files = useFileResources(userId);

  if (!files) {
    return (
      <div className="ibox mt20">
        <div className="ibox-content">
          <Loader state />
        </div>
      </div>
    );
  }

  return (
    <div className="ibox mt20">
      <div className="ibox-content">
        <div>
          <h2 className="data mt0">Vector Storage Files</h2>
        </div>
        <div className="mt10">
          <DataTable
            title=""
            columns={columns}
            data={files}
            noDataComponent="No matching records found"
            persistTableHead
          />
        </div>
      </div>
    </div>
  );
}

Index.propTypes = {
  userId: PropTypes.number.isRequired,
};
